export default class DateExtended extends Date {
    baseLocale: string = "da-DK";

    format(pattern: string, local: string = this.baseLocale) {
        let output = pattern;
        const timeElements = this.localDateTimeElements(local);

        for (const [key, value] of Object.entries(timeElements)) {
            if (output.indexOf(`[${key}]`) !== -1) {
                output = output.replace(new RegExp(key, "g"), `${value()}`);
            }
        }

        return output.replace(/\[/g, "").replace(/\]/g, "");
    }

    localDateTimeElements(local: string) {
        return {
            YYYY: () => this.getFullYear(),
            YY: () => this.getFullYear() % 100,
            DD: () => this.getDate().toString().padStart(2, "0"),
            D: () => this.getDate(),
            HH: () => this.getHours().toString().padStart(2, "0"),
            H: () => this.getHours(),
            hh: () => (this.getHours() % 12).toString().padStart(2, "0"),
            h: () => this.getHours() % 12,
            mm: () => this.getMinutes().toString().padStart(2, "0"),
            m: () => this.getMinutes(),
            ss: () => this.getSeconds().toString().padStart(2, "0"),
            s: () => this.getSeconds(),
            dddd: () => this.toLocaleDateString(local, { weekday: "long" }),
            ddd: () => this.toLocaleDateString(local, { weekday: "short" }),
            dd: () => this.toLocaleDateString(local, { weekday: "narrow" }),
            d: () => this.getDay(),
            MMMM: () => this.toLocaleDateString(local, { month: "long" }),
            MMM: () => this.toLocaleDateString(local, { month: "short" }),
            MM: () => (this.getMonth() + 1).toString().padStart(2, "0"),
            M: () => this.getMonth() + 1,
            Q: () => Math.floor(this.getMonth() / 3) + 1,
            w: () => Math.floor(this.getDate() / 7) + 1
        };
    }
}